module.exports = __webpack_public_path__ + "img/3-y-old-houdini-with-sister.3e51b46.jpg";